<header class="emptyHeaderMain"></header>
<div class="container">
  <p>
    The delete user and user index api routes are restricted to users with the
    'admin' role.
  </p>

  <ng-container *ngIf="isAdmin">
    <a class="button" routerLink="/admin/sessions-notif-emails">
      Notification Emails Settings
    </a>
    <a class="button" routerLink="/admin/session-workflow">Session Workflow</a>
    <a class="button" href="{{ dashboardUrl }}" target="_blank">Dashboard</a>
    <br />
    <br />
  </ng-container>

  <ul class="list-group user-list" *ngIf="users">
    <li class="list-group-item" *ngFor="let user of users">
      <div class="user-info">
        <strong>{{ user.name }}</strong>
        <br />
        <span class="text-muted">{{ user.email }}</span>
      </div>
      <a (click)="delete(user)" class="trash">
        <span class="fa fa-trash fa-2x"></span>
      </a>
    </li>
  </ul>
</div>
